import React from 'react';
import styled from 'styled-components';

import Colors from '../../../styles/colors';

import { CheckMarkIcon } from '../icons/CheckMarkIcon';
import { ExclamationMarkIcon } from '../icons/ExclamationMarkIcon';
import SmallSpinnerIcon from '../icons/SmallSpinnerIcon';

const STATE_COLORS = {
  loading: Colors.abnMutedGreen300,
  error: Colors.abnNegative400,
  success: Colors.abnPositive400,
};

export const MESSAGE_TYPES = {
  loading: 'loading',
  error: 'error',
  success: 'success',
};

const SmallFormMessage = ({ type, children }) => {
  const renderIcon = () => {
    switch (type) {
      case MESSAGE_TYPES.loading:
        return <SmallSpinnerIcon />;
      case MESSAGE_TYPES.error:
        return <ExclamationMarkIcon />;
      case MESSAGE_TYPES.success:
      default:
        return <CheckMarkIcon />;
    }
  };

  return (
    <Container type={type} data-testid="notification-container">
      {renderIcon()}
      <NotificationText
        data-testid="notification-text"
        data-pw-testid="notification-text"
      >
        {children}
      </NotificationText>
    </Container>
  );
};

export default SmallFormMessage;

const Container = styled.div`
  align-items: center;
  color: ${({ type }) => STATE_COLORS[type]};
  display: flex;
  font-size: 14px;
  position: relative;

  svg {
    flex-shrink: 0;
  }
`;

const NotificationText = styled.span`
  font-size: 14px;
  line-height: 14px;
  margin-left: 8px;
`;
